var bookshelf = require("../index-extended"); // ???: ..

module.exports = bookshelf.model("Invoice", {
  tableName: "invoice",
});
